import { Component, OnInit } from '@angular/core';
import {UserService} from "../../service/user.service";

@Component({
  selector: 'app-destination-detail',
  templateUrl: './destination-detail.component.html',
  styleUrls: ['./destination-detail.component.css']
})
export class DestinationDetailComponent implements OnInit {
  detail: any;
  cors: any;
  uni: any;
  showNavigationIndicators = false;

  constructor(private userService:UserService) {

  }

  ngOnInit(): void {
    this.detail =JSON.parse(localStorage.getItem('desti'));
    this.getallCourses();
    this.getallUni();
  }

  getallCourses(){
    this.userService.getallCoursesbyDesti(this.detail.id).subscribe(
        res=>{
          this.cors =res.data;
        }
    )
  }
  getallUni(){
    this.userService.getallUni(this.detail.id).subscribe(
        res=>{
          this.uni =res.data;
        }
    )
  }
}
